var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58333 5.68758C7.1346 5.68758 6.77083 6.05135 6.77083 6.50008C6.77083 6.94881 7.1346 7.31258 7.58333 7.31258H22.75C23.1987 7.31258 23.5625 6.94881 23.5625 6.50008C23.5625 6.05135 23.1987 5.68758 22.75 5.68758H7.58333Z",
    fill: "#F8F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58333 12.1876C7.1346 12.1876 6.77083 12.5514 6.77083 13.0001C6.77083 13.4488 7.1346 13.8126 7.58333 13.8126H22.75C23.1987 13.8126 23.5625 13.4488 23.5625 13.0001C23.5625 12.5514 23.1987 12.1876 22.75 12.1876H7.58333Z",
    fill: "#F8F8F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58333 18.6876C7.1346 18.6876 6.77083 19.0514 6.77083 19.5001C6.77083 19.9488 7.1346 20.3126 7.58333 20.3126H22.75C23.1987 20.3126 23.5625 19.9488 23.5625 19.5001C23.5625 19.0514 23.1987 18.6876 22.75 18.6876H7.58333Z",
    fill: "#F8F8F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41667 13.0001C5.41667 13.5984 4.93164 14.0834 4.33333 14.0834C3.73502 14.0834 3.25 13.5984 3.25 13.0001C3.25 12.4018 3.73502 11.9167 4.33333 11.9167C4.93164 11.9167 5.41667 12.4018 5.41667 13.0001Z",
    fill: "#F8F8F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41667 6.50008C5.41667 7.09839 4.93164 7.58341 4.33333 7.58341C3.73502 7.58341 3.25 7.09839 3.25 6.50008C3.25 5.90177 3.73502 5.41675 4.33333 5.41675C4.93164 5.41675 5.41667 5.90177 5.41667 6.50008Z",
    fill: "#F8F8F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41667 19.5001C5.41667 20.0984 4.93164 20.5834 4.33333 20.5834C3.73502 20.5834 3.25 20.0984 3.25 19.5001C3.25 18.9018 3.73502 18.4167 4.33333 18.4167C4.93164 18.4167 5.41667 18.9018 5.41667 19.5001Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenu);
export default __webpack_public_path__ + "static/media/mobile_menu.f0bea163f118aac4a0e75bbb27eee2e7.svg";
export { ForwardRef as ReactComponent };